import React from 'react'
import { Accordion } from '../../components/accordion'
import { ContentfulRichText } from '../../components/contentful-rich-text'

type Props = {
  questions?: readonly (Queries.FaqFragment | null)[] | null
  isActive?: boolean
  cat?: string
}

export const FaqPageQuestions = ({ cat, questions, isActive }: Props) => {
  if (!questions || questions.length === 0) {
    return null
  }
  return (
    <Accordion isActive={isActive}>
      {questions.map((faq) =>
        faq ? (
          <Accordion.Item key={faq.id} index={faq.id}>
            <Accordion.Button>{faq.question}</Accordion.Button>
            <Accordion.Content>
              <ContentfulRichText text={faq.text} />
            </Accordion.Content>
          </Accordion.Item>
        ) : null
      )}
    </Accordion>
  )
}
